document.querySelectorAll('.size-guide__tab').forEach(tab => {
  tab.addEventListener('click', function() {

    // remove active
    document.querySelectorAll('.size-guide__tab').forEach(t => t.classList.remove('active'));
    document.querySelectorAll('.size-guide__panel').forEach(p => p.classList.remove('active'));

    // add active
    this.classList.add('active');
    document.getElementById(this.dataset.tab).classList.add('active');
  });
});



document.querySelector('shopify-payment-terms') 


if (window.location.pathname.startsWith('/products/')) {

  const productStickyBar = document.querySelector('.product-sticky-bar');

  window.addEventListener('DOMContentLoaded', () => {

    if (!productStickyBar) return;

    const mainATC = document.querySelector("form[action*='/cart/add']");
    if (!mainATC) return;

    const observer = new IntersectionObserver((entries) => {

      entries.forEach(entry => {

        const rect = entry.boundingClientRect;

        if (entry.isIntersecting) {
          // ✅ ATC visible → hide sticky
          productStickyBar.classList.remove('is-visible');

        } else {
          if (rect.top < 0) {
            // ✅ ATC upar chala gaya → show sticky
            productStickyBar.classList.add('is-visible');
          } else {
            // ❌ ATC abhi niche hai (page top / image section)
            productStickyBar.classList.remove('is-visible');
          }
        }

      });

    }, {
      threshold: 0
    });

    observer.observe(mainATC);

  });

}

document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('.js-product-size').forEach(btn => {

    btn.addEventListener('click', function (e) {
      e.preventDefault();

      const variantId = this.dataset.variantId;
      if (!variantId) return;

      // Prevent double click
      this.classList.add('loading');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      })
      .then(response => {
        if (!response.ok) throw new Error('Add to cart failed');
        return response.json();
      })
      .then(() => {

        // ✅ Remove loading
        this.classList.remove('loading');

        // ✅ Refresh cart (Prestige listens to this)
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));

        // ✅ Open drawer safely (delay required)
        setTimeout(() => {
          const cartBtn = document.querySelector('a[aria-controls="cart-drawer"]');

          if (cartBtn) {
            cartBtn.dispatchEvent(new MouseEvent('click', {
              bubbles: true,
              cancelable: true
            }));
          }
        }, 400);

      })
      .catch(err => {
        console.error(err);
        this.classList.remove('loading');
      });

    });

  });

});



document.addEventListener('DOMContentLoaded', function () {

  // ✅ OPEN + CLOSE (delegation safe for variant re-render)
  document.addEventListener('click', function (e) {

    // OPEN
    const openBtn = e.target.closest('.size-guide-btn');
    if (openBtn) {
      e.preventDefault();
      const popup = document.querySelector('.size-popup');
      if (popup) popup.style.display = 'flex';
    }

    // CLOSE
    const closeBtn = e.target.closest('.size-popup .close');
    if (closeBtn) {
      const popup = document.querySelector('.size-popup');
      if (popup) popup.style.display = 'none';
    }

  });

  // ✅ TOGGLE CM / IN (delegation safe)
  document.addEventListener('change', function (e) {

    if (e.target.id === 'unitToggle') {

      const isInches = e.target.checked;

      document.querySelectorAll('.size-popup .convert').forEach(el => {
        let cm = el.dataset.cm;
        if (!cm) return;

        if (cm.includes('-')) {
          let vals = cm.split('-').map(v => parseFloat(v));
          vals = vals.map(v => isInches ? (v / 2.54).toFixed(1) : v);
          el.innerText = vals.join(' - ');
        } else {
          let v = parseFloat(cm);
          el.innerText = isInches ? (v / 2.54).toFixed(1) : v;
        }
      });

      // headers update
      document.querySelectorAll('.size-popup th[data-unit]').forEach(th => {
        const type = th.dataset.unit;

        if (type === 'chest') th.innerText = isInches ? 'Chest (in)' : 'Chest (cm)';
        if (type === 'waist') th.innerText = isInches ? 'Waist (in)' : 'Waist (cm)';
        if (type === 'hip') th.innerText = isInches ? 'Hip (in)' : 'Hip (cm)';
      });

      document.querySelector('.label.cm')?.classList.toggle('active', !isInches);
      document.querySelector('.label.in')?.classList.toggle('active', isInches);

    }

  });

});


